import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Monthly Sales Report")
  ])
], -1)
const _hoisted_4 = { class: "col-5 mt-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "City", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "All cities", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { id: "chartmontly" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formdata.city_id) = $event)),
            class: "form-control",
            onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.cityBasedCall($event)))
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cities, (city) => {
              return (_openBlock(), _createElementBlock("option", {
                key: city.id,
                value: city.id
              }, _toDisplayString(city.name), 9, _hoisted_7))
            }), 128))
          ], 544), [
            [_vModelSelect, $setup.formdata.city_id]
          ])
        ])
      ])
    ]),
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _hoisted_12
  ], 64))
}